import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=1928b9d4&scoped=true"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"
import style0 from "./menu.vue?vue&type=style&index=0&id=1928b9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928b9d4",
  null
  
)

export default component.exports